import 'magnific-popup';

$(function() {
  $('.delete_work_article_confirm').click(function() {
    $.magnificPopup.open({
      items: {src: '#popup_delete_work_article'},
      type: 'inline',
      fixedContentPos: true
    }, 0);
  });

  // 確認ダイアログを閉じる
  $('.back').click(function() {
    $.magnificPopup.close()
  })

});